module.exports = __webpack_public_path__ + "media/zoom.0f5df092.wav";